import {
  ADDITIONAL_OPTIMIZE_CLEAR,
  CERTIFICATE_QR_CODE,
  CERTIFICATE_VERIFY,
  LEFT_MENU_WITH_COUNT,
  PAYMENTS_ECHALLAN_UPDATE,
} from "../constants";
import { apiSlice } from "./apiSlice";

const dashboardApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getDashboardApplicationReport: builder.query({
      query: ({ filter, date }) => ({
        url: "/api/admin/dashboard/application-count-group-category",
        params: { filter, date },
      }),
    }),
    getCurrentActivities: builder.query({
      query: () => "/api/admin/dashboard/current-activities-group-role",
    }),
    // /admin/dashboard/certificate-endorse-count-group-category
    getCertificateEndorseCountGroupCategory: builder.query({
      query: () =>
        "/api/admin/dashboard/certificate-endorse-count-group-category",
    }),
    // /admin/dashboard/statistics-at-a-glance
    getStatisticsAtAGlance: builder.query({
      query: () => "/api/admin/dashboard/statistics-at-a-glance",
    }),
    optimizeClear: builder.query({
      query: () => ADDITIONAL_OPTIMIZE_CLEAR,
      keepUnusedDataFor: 0,
    }),
    // PAYMENTS_ECHALLAN_UPDATE
    updatePaymentEchallon: builder.mutation({
      query: (data) => ({
        url: PAYMENTS_ECHALLAN_UPDATE,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["verify_echalan"],
    }),
    getLeftMenuCount: builder.query({
      query: () => LEFT_MENU_WITH_COUNT,
      keepUnusedDataFor: 2,
    }),

    // CERTIFICATE_QR_CODE
    getCertificateQRCode: builder.query({
      query: ({ profileId, user_id }) => ({
        url: `${CERTIFICATE_QR_CODE}/${profileId}?size=30&user_id=${user_id}`,
      }),
      transformResponse: (response) => response?.data,
      providesTags: ["get_qr_code"],
    }),

    // CERTIFICATE_VERIFY
    verifyCertificate: builder.query({
      query: ({ regNo, issued }) => ({
        url: CERTIFICATE_VERIFY,
        params: { regNo, issued },
      }),
    }),
  }),
});

export const {
  useGetDashboardApplicationReportQuery,
  useGetCurrentActivitiesQuery,
  useGetCertificateEndorseCountGroupCategoryQuery,
  useGetStatisticsAtAGlanceQuery,
  useLazyOptimizeClearQuery,
  useUpdatePaymentEchallonMutation,
  useGetLeftMenuCountQuery,
  useGetCertificateQRCodeQuery,
  useVerifyCertificateQuery,
} = dashboardApiSlice;
